import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subject", "body", "subjectPreview", "bodyPreview", "variables"]
  static values = { previewUrl: String }

  connect() {
    this.sampleData = {
      guest_name: "John Smith",
      event_title: "Sarah's Birthday Party",
      event_date: "Saturday, January 15, 2026",
      event_time: "6:00 PM",
      event_location: "123 Main Street, San Francisco, CA",
      host_name: "Sarah Johnson",
      rsvp_url: "https://example.com/rsvp/abc123",
      gift_name: "Kitchen Stand Mixer",
      gift_price: "$299.99",
      custom_message: "Your generosity means the world to us!",
      days_until_event: "7"
    }
    if (this.hasSubjectPreviewTarget) {
      this.subjectPreviewTarget.setAttribute("aria-live", "polite")
    }
    if (this.hasBodyPreviewTarget) {
      this.bodyPreviewTarget.setAttribute("aria-live", "polite")
    }
    this.updatePreview()
  }

  updatePreview() {
    if (this.hasSubjectTarget && this.hasSubjectPreviewTarget) {
      const subject = this.subjectTarget.value || "Your subject line"
      this.subjectPreviewTarget.textContent = this.substituteVariables(subject)
    }

    if (this.hasBodyTarget && this.hasBodyPreviewTarget) {
      const body = this.bodyTarget.value
      if (body) {
        this.bodyPreviewTarget.innerHTML = this.substituteVariables(body)
      } else {
        this.bodyPreviewTarget.innerHTML = '<p class="text-gray-400 text-center py-8">Your email preview will appear here</p>'
      }
    }
  }

  substituteVariables(text) {
    let result = text
    for (const [key, value] of Object.entries(this.sampleData)) {
      result = result.replace(new RegExp(`{{${key}}}`, 'g'), value)
    }
    return result
  }

  insertVariable(event) {
    event.preventDefault()
    const variable = event.currentTarget.dataset.variable
    
    if (this.hasBodyTarget && document.activeElement === this.bodyTarget) {
      this.insertAtCursor(this.bodyTarget, variable)
    } else if (this.hasSubjectTarget) {
      this.insertAtCursor(this.subjectTarget, variable)
    }
    
    this.updatePreview()
  }

  insertAtCursor(input, text) {
    const start = input.selectionStart
    const end = input.selectionEnd
    const value = input.value

    input.value = value.substring(0, start) + text + value.substring(end)
    input.selectionStart = input.selectionEnd = start + text.length
    input.focus()
  }

  typeChanged(event) {
    const variablesByType = {
      invitation: ['{{guest_name}}', '{{event_title}}', '{{event_date}}', '{{event_time}}', '{{event_location}}', '{{host_name}}', '{{rsvp_url}}'],
      thank_you: ['{{guest_name}}', '{{event_title}}', '{{event_date}}', '{{event_time}}', '{{event_location}}', '{{host_name}}', '{{gift_name}}', '{{gift_price}}', '{{custom_message}}'],
      reminder: ['{{guest_name}}', '{{event_title}}', '{{event_date}}', '{{event_time}}', '{{event_location}}', '{{host_name}}', '{{rsvp_url}}', '{{days_until_event}}']
    }

    const type = event.target.value
    const variables = variablesByType[type] || []

    if (this.hasVariablesTarget) {
      this.variablesTarget.innerHTML = variables.map(v => 
        `<button type="button" class="badge badge-secondary cursor-pointer hover:bg-gray-300" data-action="click->template-editor#insertVariable" data-variable="${v}">${v}</button>`
      ).join('')
    }
  }
}
